/* istanbul ignore next */
export const reduxStore = { store: null };

export default { reduxStore };
